import { Dropdown } from 'antd';
import styled from 'styled-components';

export const StyledCallCounter = styled.div`
  background: rgba(41, 80, 243, 0.1);
  border-radius: 4px;
  min-width: 200px;
  text-align: center;
  color: #4385f5;
  padding: 6px;
  font-size: 14px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledButton = styled(Dropdown.Button)`
  button:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 200px;
    @media only screen and (max-width: 768px) {
      min-width: 100%;
    }
  }
`;
